import { render, staticRenderFns } from "./navHeader.vue?vue&type=template&id=01ec0483&scoped=true&"
import script from "./navHeader.vue?vue&type=script&lang=js&"
export * from "./navHeader.vue?vue&type=script&lang=js&"
import style0 from "./navHeader.vue?vue&type=style&index=0&id=01ec0483&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ec0483",
  null
  
)

export default component.exports